
<script>
import { useAlert } from 'dashboard/composables';

export default {
  name: 'SelectBranch',
  props: {
    value: {
      type: [String, Number, Object, null],
      default: null
    }
  },
  data() {
    return {
      branchList: [],
      isDropdownOpen: false,
      branchCurrentPage: 1,
      branchTotal: 0,
      branchTotalPages: 1,
      branchNextPage: false,
      selectedBranchId: null,
    };
  },
  computed: {
    getCurrentAccountId() {
      return this.$store.getters['getCurrentAccountId'];
    },
    selectedBranch: {
      get() {
        return this.value || null;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
  },
  watch: {
    async branchCurrentPage() {
      await this.fetchBranches();
    },
    value(newVal) {
      this.selectedBranch = newVal || null;
      this.selectedBranchId = newVal?.branch_id || null;
    }
  },
  methods: {
    async fetchBranches() {
      try {
        // getActiveRentalBranches expects { page, page_size }
        const res = await this.$store.dispatch('rentalBranch/getActiveRentalBranches', { page: this.branchCurrentPage, page_size: 10 });
        this.branchList = res.results || [];
        this.branchTotal = res.total || 0;
        this.branchTotalPages = Math.ceil(this.branchTotal / 10) || 1;
        this.branchNextPage = res.next && res.next !== -1;
      } catch (err) {
        useAlert('Failed to load branches');
        this.branchList = [];
      }
    },
    selectBranch(branch) {
      this.selectedBranchId = branch.branch_id;
      this.selectedBranch = branch; 
      this.$emit('selected', branch);
      this.isDropdownOpen = false;
    },
    closeDropdownWithDelay() {
      setTimeout(() => {
        this.isDropdownOpen = false;
      }, 200);
    },
    nextPage() {
      if (this.branchNextPage) {
        this.branchCurrentPage++;
      }
    },
    prevPage() {
      if (this.branchCurrentPage > 1) {
        this.branchCurrentPage--;
      }
    }
  },
  mounted() {
    this.fetchBranches();
  }
};
</script>

<template>
  <label class="block relative mb-4">
    <span class="text-sm font-medium text-slate-700 dark:text-slate-300">
      Select Branch
    </span>
    <div
      class="overflow-hidden border-slate-200 mt-1 w-full border rounded-md text-slate-900 dark:text-white dark:bg-slate-700 dark:border-slate-600 focus-within:ring-2 focus-within:ring-woot-500"
    >
      <div
        class="reset-base w-full p-2 dark:bg-transparent bg-white border-none focus:outline-none cursor-pointer"
        @click="isDropdownOpen = true"
        tabindex="0"
        @focus="isDropdownOpen = true"
        @blur="closeDropdownWithDelay"
      >
        <span v-if="selectedBranchId">
          {{ (branchList.find(b => b.branch_id === selectedBranchId) || {}).branch_name || 'Select a branch...' }}
        </span>
        <span v-else class="text-slate-400">Select a branch...</span>
      </div>
      <div
        v-if="isDropdownOpen"
        class="fixed inset-0 z-40"
        @click="isDropdownOpen = false"
      ></div>
      <div
        v-if="isDropdownOpen"
        class="absolute z-50 left-0 right-0 mt-1 bg-white dark:bg-slate-700 border rounded-md shadow-lg max-h-60 overflow-y-auto"
      >
        <div v-if="branchList.length === 0" class="p-2 text-slate-500">
          No branches found
        </div>
        <div v-else>
          <div
            v-for="branch in branchList"
            :key="branch.branch_id"
            @click.prevent="selectBranch(branch)"
            class="p-2 hover:bg-woot-100 dark:hover:bg-woot-700 cursor-pointer flex items-center gap-2"
          >
            <span class="font-medium">{{ branch.branch_name }}</span>
            <span class="text-xs text-slate-500 ml-2">{{ branch.address }}</span>
          </div>
          <div class="flex items-center justify-between p-2 border-t">
            <button @click="prevPage" :disabled="branchCurrentPage === 1" class="text-xs px-2 py-1 rounded bg-slate-200 dark:bg-slate-600">Prev</button>
            <span class="text-xs">Page {{ branchCurrentPage }} of {{ branchTotalPages }}</span>
            <button @click="nextPage" :disabled="!branchNextPage" class="text-xs px-2 py-1 rounded bg-slate-200 dark:bg-slate-600">Next</button>
          </div>
        </div>
      </div>
    </div>
  </label>
</template>